<div
  id="sticky-progress-bar"
  class="right-0 bottom-0 left-0 z-30 fixed flex justify-between items-center gap-6 bg-black px-4 md:px-8 lg:px-10 py-2 w-full text-white">
  <!-- Breadcrumb (hidden on mobile to leave room for the CTA) -->
  <div class="hidden lg:flex items-center gap-2 min-w-0 text-xs">
    @for (step of steps(); track step; let i = $index; let last = $last) {
      <span
        class="whitespace-nowrap"
        [class.font-bold]="i + 1 === currentStep()"
        [class.opacity-50]="i + 1 !== currentStep()">
        {{ i + 1 }}. {{ step }}
      </span>
      @if (!last) {
        <span class="opacity-30 w-6 border-current border-t"></span>
      }
    }
  </div>

  <!-- Page-specific totals slot -->
  <div class="flex flex-1 justify-center lg:justify-end items-center min-w-0">
    <ng-content></ng-content>
  </div>

  <!-- CTA -->
  <!--
    `text-xs` matches `app-best-seats`' own CTA (select-seat/sidebar/filters/partials/best-seats):
    both share `.btn-main`'s club-colour pill (bg/rounded-full/w-28) and this component's own
    `#sticky-progress-bar button { height: 2rem }` override (same 32px as Add Best Seats' `h-8`),
    so `text-xs` is the one piece `.btn-main`'s own `text-sm` didn't already give it for free.
  -->
  <button
    type="button"
    [attr.data-cy]="ctaDataCy()"
    class="flex justify-center items-center gap-1.5 min-w-max text-xs disabled:hover:transform-none hover:scale-95 transition-transform"
    [ngClass]="[
      ctaClasses,
      ctaVariant() === 'success' || (ctaVariant() === 'main' && ctaDisabled())
        ? ''
        : 'disabled:opacity-30',
    ]"
    [disabled]="ctaDisabled()"
    [title]="ctaTooltip()"
    (click)="onCtaClick()">
    {{ ctaLabel() }}
    <!-- Lock icon — payment-submit state only, see ctaShowLockIcon(). -->
    @if (ctaShowLockIcon()) {
      <img
        src="/assets/img/lock-icon-white.svg"
        alt=""
        class="w-[12.7px] h-[16.7px]" />
    }
  </button>
</div>
